{
  "userPoolClientId": "41qndcme8as5roof7a66udt898",
  "userPoolId": "us-east-1_q3e9t06Tk",
  "identityPoolId": "us-east-1:93414993-6a06-48c8-9733-79c8fb23002d",
  "appId": "b0b121716c3942a08a1e791218ae9deb"
}
